import { CurrencyPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'price',
	pure: true,
})
export class PricePipe implements PipeTransform {
	private readonly currencyPipe = inject(CurrencyPipe);
	private readonly translate = inject(TranslateService);

	language: string;

	constructor() {
		this.language =
			this.translate.currentLang ?? this.translate.defaultLang;
	}

	transform(priceInCents: number, currency: string): string | null {
		return this.currencyPipe.transform(
			priceInCents / 100,
			currency,
			'symbol-narrow',
			'1.2-2',
			this.language,
		);
	}
}
